import RadiologyMainSection from "../PageElements/RadiologyPageElement/RadiologyMainSection";

export default function RadiologyFooterPage(){
    return(
        <>
        <RadiologyMainSection/>
        </>
    )
}